import React, { useContext, useEffect, useState } from 'react';

import { useDispatch, useSelector } from "react-redux";

import { EditorContext } from 'components/Editor';

import cx from 'classnames';
import { Row, Col } from "react-bootstrap";
import _ from 'lodash';

import styles from './prompt.module.scss';


const PromptWidgetComponent = function ({ widgetProps, widgetRef, className, style, children }) {
  const dispatch = useDispatch();
  const ref = widgetRef;
  const editorContext = useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const currentBreakpoint = useSelector((state) => _.get(state, `${editorSession}.present.breakpoint`));

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');

  const content = widgetProps.content;


  return (
    <div
      id={id}
      ref={ref}
      className={cx(styles.promptWidget, className)}
      style={style}
      data-widget-id={id}
      data-widget-type={type}
      data-selectable={true}
    >
      <FrameSkeletonLoader content={content} />
    </div>
  );
};

const promptWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'widgetRef', 'children'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const PromptWidget = React.memo(PromptWidgetComponent, promptWidgetEquals);

PromptWidget.moveableConfig = (editorSession, widget) => {
  return {
    draggable: false,
    resizable: false,
    rotatable: false,
    selectable: false,
    cloneable: false,
    deletable: true,
    renderDirections: []
  }
}

PromptWidget.actions = (editor, breakpoint, props) => {
  return null;
}

PromptWidget.processRequest = (widget) => {
  return widget;
}


const FrameSkeletonLoader = React.memo(({ content }) => {

  const [loadingMessages, setLoadingMessages] = useState("");
  const typewriterScrollRef = React.useRef(null);

  useEffect(() => {
    if (content) {
      setLoadingMessages(`Name: ${content.name}\nGoal: ${content.plan}`);
    }
  }, [content]);

  
  const LEFT_MESSAGES = [
    "Analyzing content...",
    "Building frame...",
    "Adding elements...",
    "Styling components...",
    "Putting everything together...",
    "Finalizing the content...",
  ];
  const [leftIndex, setLeftIndex] = useState(0);
  const [rightText, setRightText] = useState("");

  // Left carousel animation
  useEffect(() => {
    const interval = setInterval(() => {
      setLeftIndex((prev) => (prev + 1) % LEFT_MESSAGES.length);
    }, 2500); // Change message every 2.5s

    return () => clearInterval(interval);
  }, []);

  // Right typewriter animation
  useEffect(() => {
    let currentIndex = 0;
    let timeout;

    const type = () => {
      if (loadingMessages && currentIndex < loadingMessages.length) {
        setRightText(loadingMessages.slice(0, currentIndex + 1));
        currentIndex++;
        timeout = setTimeout(type, 100); // 100ms per letter
      } else {
        // Finished typing, wait 2s then restart
        timeout = setTimeout(() => {
          setRightText("");
          currentIndex = 0;
          type();
        }, 2000);
      }
    };

    type();

    return () => clearTimeout(timeout);
  }, [loadingMessages]);

  // Auto-scroll to bottom as typing progresses
  useEffect(() => {
    if (typewriterScrollRef.current) {
      typewriterScrollRef.current.scrollTop = typewriterScrollRef.current.scrollHeight;
    }
  }, [rightText]);

  return (
    <div className={styles.loaderContainer}>
      <div className={styles.contentWrapper}>
        <Row className={styles.contentRow}>
          <Col className={styles.leftAnimationContent} sm={6}>
            <div className={styles.box}>
              <div className={styles.carouselContainer}>
                <div
                  className={styles.carouselTrack}
                  style={{
                    transform: `translateY(${40 - leftIndex * 40}px)`
                  }}
                >
                  {LEFT_MESSAGES.map((message, i) => {
                    const offset = i - leftIndex;
                    const isCenter = offset === 0;
                    return (
                      <div
                        key={i}
                        className={cx(styles.carouselItem, {
                          [styles.carouselItemCenter]: isCenter,
                          [styles.carouselItemAdjacent]: Math.abs(offset) === 1,
                        })}
                        style={{
                          transform: `translateY(${i * 40}px)`
                        }}
                      >
                        {message}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </Col>
          <Col className={styles.rightAnimationContent} sm={6}>
            <div className={styles.typewriterBoxWrapper}>
              <div ref={typewriterScrollRef} className={styles.typewriterScrollBox}>
                <div className={styles.typewriterContainer}>
                  <p className={styles.typewriterText}>
                    {rightText}
                    <span className={styles.cursor}>|</span>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
});